export const PAGE_COUNT = 20;
export const LISTED_COMPANY_LIST = ['전체', 'KOSDAQ', 'KOSPI', 'KONEX'];
